/* * @Author: 曹俊杰 * @Date: 2023-01-03 16:02:31 * @Module: 菜单 */
<template>
  <ul class="menu">
    <router-link
      v-for="item in menuList"
      class="item pointer"
      :target="item.target"
      active-class="def-active"
      :key="item.name"
      :to="`/${item.name}`"
      v-show="authFn(item)"
    >
      <li>
        {{ item.title }}
        <div class="line"></div>
      </li>
    </router-link>
  </ul>
</template>
<script>
import menuAuthority from "./menuAuthority.js";

export default {
  mixins: [menuAuthority],
  components: {},
  data() {
    return {
      menuList: [
        {
          title: "工作台",
          name: "home",
          target: "_self",
          authority: [],
        },
        {
          title: "合同",
          target: "_self",
          name: "electronicDocumentsList",
          authority: ["companyAuth"],
        },
        {
          title: "风险排查",
          name: "inspect",
          target: "_self",
          authority: ["companyAuth"],
        },
        {
          title: "账户中心",
          target: "_self",
          name: "accountCenter",
          authority: ["userAuth"],
        },
        {
          title: "智库",
          target: "_self",
          name: "thinktank",
          authority: ["userAuth"],
        },
        {
          title: "三方服务",
          target: "_self",
          name: "thirdPartyServices",
          authority: ["companyAuth"],
        },
          {
          title: "广场信息",
          target: "_self",
          name: "Information",
          authority: ["companyAuth"],
        },
        //  {
        //   title: '出证',
        //   target: '_self',
        //   name: 'accurateEvidence',
        //   authority: ['companyAuth']
        // },
        // {
        //   title: '权益执行',
        //   target: '_self',
        //   name: 'equity',
        //   authority: ['companyAuth']
        // },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.menu {
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  gap: 40px;
  .item {
    position: relative;
    color: #666666;
    font-weight: 400;
  }
  .def-active {
    color: #262626 !important;
    font-weight: 500;
    .line {
      width: 16px;
      height: 3px;
      border-radius: 10px;

      font-weight: 500;
      display: block;
      background: #0062ff;
      position: absolute;
      bottom: -8px;
    }
  }

  .line {
    width: 16px;
    height: 2px;
    border-radius: 8px;
    position: absolute;
    top: 30px;
    left: 0;
    right: 0;
    margin: auto;
    display: none;
  }
}
</style>
